import { Injectable } from '@angular/core';
import { StorageService } from '../storageService/storage.service';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    private THEME_KEY = 'darkTheme';
    private darkTheme!: boolean;

    constructor(private storage: StorageService) {
        this.darkTheme = this.storage.getItem(this.THEME_KEY) === 'true';
        this.applyTheme();
    }

    private applyTheme(): void {
        if (this.darkTheme) {
            document.body.classList.add('dark-theme');
        } else {
            document.body.classList.remove('dark-theme');
        }
    }

    isDarkTheme(): boolean {
        return this.darkTheme;
    }

    toggleTheme(): void {
        this.darkTheme = !this.darkTheme;
        this.storage.saveItem(this.THEME_KEY, this.darkTheme.toString());
        this.applyTheme();
    }
}